import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["RegisterForm"] */ "/app/src/components/auth/register/RegisterForm.tsx");
